import { EffectCallback, ReactElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent'
import { RootState } from 'redux/store'
import { updateAppInfoState } from 'redux/appInfo/appInfoSlice'
import { userAccountInfo } from 'helpers/user'
import { getCorrelationID } from 'helpers/requestParams'

const RefreshModal = (): ReactElement => {
  const dispatch = useDispatch()
  const { isUserLoggedIn, isSessionStarted } = useSelector(
    ({ appInfo }: RootState) => appInfo
  )
  const handleBeforeUnload = (event: CustomEvent): void => {
    /*
     * Prevent the Reload popup when Surfly is active from both the iframe and
     * main app
     */
    if (window.Surfly?.listSessions().length === 0) {
      event.preventDefault()
      // eslint-disable-next-line no-param-reassign
      event.returnValue = false
    }
  }

  const loadEvent = (): EffectCallback => {
    if (isUserLoggedIn) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }
    return (): void =>
      window.removeEventListener('beforeunload', handleBeforeUnload)
  }

  useEffect(() => {
    loadEvent()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoggedIn])

  const getTrackingID = (): void => {
    if (!isSessionStarted) {
      const trackingId = getCorrelationID()
      userAccountInfo.trackingInfo = trackingId
      analyticsConfig.defaults.Token = trackingId
      dispatch(
        updateAppInfoState({
          isSessionStarted: true
        })
      )
    }
  }

  useEffect(() => {
    getTrackingID()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionStarted])

  return <div />
}

export default RefreshModal
